import { useMediaQuery, useTheme } from '@mui/material';

type HiddenProps = {
    children: React.ReactNode;
    xsDown?: boolean;
    xsUp?: boolean;
    smDown?: boolean;
    smUp?: boolean;
    mdDown?: boolean;
    mdUp?: boolean;
    lgDown?: boolean;
    lgUp?: boolean;
    xlDown?: boolean;
    xlUp?: boolean;
};

export default function Hidden({
    children,
    xsDown,
    xsUp,
    smDown,
    smUp,
    mdDown,
    mdUp,
    lgDown,
    lgUp,
    xlDown,
    xlUp,
}: HiddenProps) {
    const theme = useTheme();

    const isXsDown = useMediaQuery(theme.breakpoints.down('sm'));
    const isXsUp = useMediaQuery(theme.breakpoints.up('xs'));
    const isSmDown = useMediaQuery(theme.breakpoints.down('md'));
    const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
    const isMdDown = useMediaQuery(theme.breakpoints.down('lg'));
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
    const isLgDown = useMediaQuery(theme.breakpoints.down('xl'));
    const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
    const isXlUp = useMediaQuery(theme.breakpoints.up('xl'));

    const shouldHide =
        (xsDown && isXsDown) ||
        (xsUp && isXsUp) ||
        (smDown && isSmDown) ||
        (smUp && isSmUp) ||
        (mdDown && isMdDown) ||
        (mdUp && isMdUp) ||
        (lgDown && isLgDown) ||
        (lgUp && isLgUp) ||
        (xlDown && isLgDown) ||
        (xlUp && isXlUp);

    if (shouldHide) {
        return null;
    }

    return children;
}
